/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

window.flatpickr = require('flatpickr').default;
window.moment = require('moment');
require("jquery-mask-plugin");

require("select2");
$.fn.select2.defaults.set("theme", "bootstrap");

window.Cookies = require("js-cookie");
window.lazysizes = require('lazysizes');

$(function() {
    $('[data-toggle="tooltip"]').tooltip();

    $(".select2-element").select2({
        allowClear: true,
    });

    document.addEventListener('lazyloaded', function(e) {
        $(e.target).closest('.image-wrapper').removeClass('image-loading');
    });

    function is_touch_device() {
        return 'ontouchstart' in window // works on most browsers
            ||
            navigator.maxTouchPoints; // works on IE10/11 and Surface
    }
});
